import React,{Component} from 'react';


class Loader extends Component{
	
	render(){
		console.log(this.props.isLoading,"loading")
		if(this.props.isLoading){
			return(
				<div className='loading'>
					
				</div>
			);
		}
		return null;
	}
}

export default Loader;